import { createApi } from '@reduxjs/toolkit/query/react';

import { CustomerAgentStatus } from '@/types/agentsAgentDesk';
import { TChatbot } from '@/types/chatbot';

import { baseQueryWithReauth } from './utils';

export interface IGetCustomerChatOutputDto {
  referenceId: string;
  name: string;
  status?: CustomerAgentStatus;
  chatbot?: TChatbot;
  assignedUsers?: Array<{ userName?: string; fullName?: string }>;
  lastExecution?: string;
  description?: string;
  [key: string]: unknown;
}

export type TGetCustomerChatsDto = {
  search?: string;
  limit?: number;
  page?: number;
  statuses?: CustomerAgentStatus[];
  startAt?: string;
  endAt?: string;
  customerIds?: string[];
};

export type TGetCustomerChatsResponse = {
  items: IGetCustomerChatOutputDto[];
  pagination: { page: number; limit: number; totalPages: number; total?: number };
  healthyChatbots: number;
  warningChatbots: number;
  criticalChatbots: number;
};

export type TChatRunHistoryItem = {
  referenceId: string;
  status: string;
  createdAt: string;
  finishedAt?: string;
  description?: string;
};

export type TChatRunHistoryResponse = {
  items: TChatRunHistoryItem[];
  pagination: { page: number; limit: number; totalPages: number; total: number };
};

export const chatsApi = createApi({
  reducerPath: 'chatsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getCustomerChats: build.query<TGetCustomerChatsResponse, TGetCustomerChatsDto | void>({
      query: (params) => ({
        url: '/chatbot/get-customer-chatbots',
        method: 'POST',
        body: {
          page: 1,
          limit: 6,
          ...params,
        },
      }),
    }),
    getCustomerChatbot: build.query<IGetCustomerChatOutputDto, string>({
      query: (referenceId: string) => ({
        url: 'chatbot/get-customer-chatbot',
        method: 'GET',
        params: { referenceId },
      }),
    }),
    getChatbotRunHistory: build.query<TChatRunHistoryResponse, { customerChatbotId: string; page: number; limit: number }>({
      query: (params) => ({
        url: 'run-history/get-chatbot-run-histories',
        method: 'POST',
        body: params,
      }),
    }),
  }),
});

export const { useGetCustomerChatsQuery, useGetCustomerChatbotQuery, useGetChatbotRunHistoryQuery } = chatsApi;
